import MenuItem from "~/cabinet/vue/interface/menu/MenuItem";

export default class MenuItemTitle extends MenuItem {
    constructor(title: string) {
        super("", title);
        this.title = true;
    }

    get isSelectable(): boolean {
        return false;
    }
}